















































import { editFactory } from '@/main/pages';

import Base from './Base.vue';
import { NAME, INVENTORY_PARTS_DATA, DEPENDENT_TABLES } from '../constants';
import { apiProvider } from '../api';
import { store } from '../store/edit';


export default editFactory(NAME, store).extend({
	name: 'Inventorydashboard',
	components: {
		BaseFilterSestav: Base,
	},
	data() {
		return {
			NoOfUnitsAvaList: [
				{ Text: this.Localize('1month'), Value: 1 },
				{ Text: this.Localize('3-6month'), Value: 2 },
				{ Text: this.Localize('6-12month'), Value: 3 },
				{ Text: this.Localize('12-24month'), Value: 4 },
				{ Text: this.Localize('24-36month'), Value: 5 },
				{ Text: this.Localize('>36month'), Value: 6 },
			],
			dependencies: DEPENDENT_TABLES,
			InventoryPartsDataFilter: null as any | null,
		};
	},
	computed: {
		inventoryPartsData(): string {
			return 'InventoryPartsData';
		},
		canGenerateReport(): boolean {
			return !this.dmsSys.EnableTaiwanPrp;
		},
	},
	methods: {
		async loadData() {
			await this.fetchTableSchemas([INVENTORY_PARTS_DATA]);
			const resolvedPromisesArray = [apiProvider.getSkladMistoData(), apiProvider.getDealerKVPSDDData(), apiProvider.getPartsCategoryDDData()];
			const [SkladMisto, DealerKVPSList, PartsCategory] = await Promise.all(resolvedPromisesArray);
			this.dropdownList.SkladMisto = SkladMisto.data;
			this.dropdownList.DealerKVPSList = DealerKVPSList.data;
			this.dropdownList.PartsCategory = PartsCategory.data;
		},

		async partsDetailsTable() {
			this.InventoryPartsDataFilter = {
				SkladMistoId: this.SkladMistoId,
				DealerId: this.DealerId,
				PartCategoryId: this.PartCategoryId,
				ND_NR: this.ND_NR,
				PartDescription: this.PartDescription,
				NoOfUnitsAvaVal: this.NoOfUnitsAvaVal,
				LastOrderedDate: this.LastOrderedDate,
				OldestStockAge: this.OldestStockAge,
				NewStockAge: this.NewStockAge,
				AvgStockAge: this.AvgStockAge,
			};

			this.refreshTable(INVENTORY_PARTS_DATA);
		},
	},
});
